// src/components/ui/ServiceCarousel.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Award, Shield, Heart } from 'lucide-react';
import Carousel from './Carousel';
import ServiceCard from './ServiceCard';
import { services } from '../../data/services';
import { useServices } from '../../hooks/useServices';
import { fadeInUp } from '../../utils/animations';

const ServiceCarousel: React.FC = () => {
  const { getPopularServices } = useServices();
  const popularServices = getPopularServices();

  const serviceFeatures = [
    {
      icon: <Shield size={24} />,
      title: 'Hospital-Grade Sterilization',
      description: 'All tools are autoclave sterilized or single-use'
    },
    {
      icon: <Award size={24} />,
      title: 'Certified Technicians',
      description: 'Internationally trained with 5+ years experience'
    },
    {
      icon: <Sparkles size={24} />,
      title: 'Premium Products',
      description: 'High-quality international and local Ghanaian products'
    },
    {
      icon: <Heart size={24} />,
      title: 'Custom Designs',
      description: 'Personalized nail art to match your style'
    }
  ];

  return (
    <div className="space-y-16">
      {/* Popular Services */}
      <div>
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-mauve-900 mb-4">
            Most Popular Services
          </h2>
          <p className="text-lg text-mauve-600 max-w-2xl mx-auto">
            Our clients' favorite treatments in Accra
          </p>
        </div>

        <Carousel
          autoPlay={false}
          showControls={true}
          showDots={true}
          showArrows={true}
        >
          {popularServices.map((service) => (
            <div key={service.id} className="px-2">
              <ServiceCard service={service} />
            </div>
          ))}
        </Carousel>
      </div>

      {/* Service Features */}
      <motion.div
        initial="initial"
        animate="animate"
        variants={{
          animate: {
            transition: {
              staggerChildren: 0.1
            }
          }
        }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"
      >
        {serviceFeatures.map((feature, index) => (
          <motion.div
            key={index}
            variants={fadeInUp}
            className="bg-white rounded-2xl p-6 shadow-lg border border-mauve-100 hover:shadow-xl transition-shadow"
          >
            <div className="text-mauve-500 mb-4">{feature.icon}</div>
            <h3 className="text-xl font-bold text-mauve-900 mb-3">
              {feature.title}
            </h3>
            <p className="text-mauve-700">{feature.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default ServiceCarousel;